/**
 *
 *@author xujinjiang
 *@date 2022/3/30 11:00
 */
import { UrlConfig } from '@/config/UrlConfig';

export class WebsiteUrlConfig {
  public static apply = `${UrlConfig.websiteBaseurl}/thirdparty/apply`;

  public static verificationCode = `${UrlConfig.websiteBaseurl}/v2/thirdparty/auth/verification/code`;
}
